// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xIDp","colMin":"styles_colMin__12KS6"};